// extracted by mini-css-extract-plugin
export default {"App":"App_App__wHwor","Footer":"App_Footer__k+Nsy"};